import { useMemo } from 'react';
import { makeApiClient } from './api/client.js';
import { AuthProvider, useAuth } from './auth/AuthContext.js';
import { Dashboard } from './components/Dashboard.js';
import { Login } from './components/Login.js';

function Inner() {
  const { isAuthenticated, password } = useAuth();
  const client = useMemo(() => makeApiClient(() => password), [password]);
  return isAuthenticated ? <Dashboard client={client} /> : <Login />;
}

export function App() {
  return (
    <AuthProvider>
      <Inner />
    </AuthProvider>
  );
}
